import React, { useState } from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../profile/Urls';
import DataCard from './DataCard';
import { PayloadStates } from '@lore/utils';
import useUserTags from '../../hooks/useUserTags';
import TagTypes from '../../constants/TagTypes';

export default function Subjects(props) {
  const { user } = props;

  const { history } = useRouter();

  const [timestamp] = useState(new Date().toISOString());

  const userSubjects = useUserTags(user, TagTypes.Subject, timestamp);

  let subtitle = '';

  if (userSubjects.state === PayloadStates.FETCHING) {
    subtitle = '...';
  } else {
    subtitle = userSubjects.data.map(function(userSubject, index) {
      return (
        <div key={index}>
          {userSubject.data.name}
        </div>
      );
    });
  }

  return (
    <DataCard
      title="Subjects"
      icon={BookOpenIcon}
      subtitle={subtitle || '(not provided)'}
      onClick={() => history.push(Urls(user).SUBJECTS)}
    />
  );
};
